import React, { useState, useEffect } from "react";
import axios from "axios";
import { useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import DataTable from "../../Student/Reusablecomponents/DataTable/DataTable";
import Loading from "../../Student/Reusablecomponents/Loading";
import { useNavigate } from "react-router-dom";
const PTracker = (props) => {
  const location = useLocation();
  const navigate = useNavigate();

  const items = useSelector((state) => state.userDetailsData.LoginDetails);
  const SelectLanguage = useSelector(
    (state) => state.SelectLanguageData.SLanguage
  );
  const [PTDetails, SetPTDetails] = useState();
  const [Load, SetLoad] = useState(false);
  const GeTotal = async () => {
    SetLoad((prev) => !prev);
    await axios
      .get(
        process.env.REACT_APP_API_BASE_URL +
          `/QuestionBank/GetMappedQuestionCountBYSubject?SubjectId=${items?.subjectId}&QBCategoryCode=${location.state?.Tab}&LanguageId=${SelectLanguage}`,
        { headers: { XApiKey: process.env.REACT_APP_XApiKey } }
      )
      .then((res) => {
        GetProgresstracker(res.data);
      })
      .catch((err) => console.log(err));
  };
  const GetProgresstracker = async (TotalValues) => {
    await axios
      .get(
        process.env.REACT_APP_API_BASE_URL +
          `/QuestionBank/GetQbProgressTracker?QBCategoryCode=${location.state?.Tab}&SubjectID=${items?.subjectId}&LanguageId=${SelectLanguage}`,
        { headers: { XApiKey: process.env.REACT_APP_XApiKey } }
      )
      .then((res) => {
        if (res.data[0]?.qbAdminUserId) {
          const Total = {
            week: "Total",
            loginId: "",
            grade: "",
            qsMappedToFramework: TotalValues?.[0]?.mappedQuestions,
            qsMappedRem: TotalValues?.[0]?.mappedRemediation,
          };
          SetPTDetails([Total, ...res.data]);
        } else {
          SetPTDetails(process.env.REACT_APP_NODATAFOUND);
        }
        SetLoad((prev) => !prev);
      })
      .catch((err) => console.log(err));
  };

  useEffect(() => {
    GeTotal();
  }, [location.state?.Tab, SelectLanguage]);
  const PTColumns = [
    { name: "Time Point", selector: "week", sortable: true },
    { name: "QBADMIN Login user", selector: "loginId", sortable: true },
    { name: "Grade", selector: "gradeName", sortable: true },
    {
      name: "No. (and %) of Questions Mapped to Assessment Framework",
      selector: "qsMappedToFramework",
      sortable: true,
      cell: (row) => (
        <div
          className={row.week !== "Total" && "LinkStyles"}
          onClick={() => {
            if (row.week !== "Total") {
              navigate(`/QBAdmin/Progresstracker/DrillDown`, {
                state: { Tab: location.state?.Tab, PTDetaisl: row },
              });
            }
          }}
        >
          {row.qsMappedToFramework}{" "}
          {row.week !== "Total" && `(${row.totalQsMappedToFrameworkPer}%)`}{" "}
        </div>
      ),
    },
    {
      name: "No. (and %) of Questions Mapped to Remedial Content.",
      selector: "qsMappedRem",
      sortable: true,
      cell: (row) => (
        <div>
          {row.qsMappedRem}{" "}
          {row.week !== "Total" && `(${row.totalQsMappedToRemPer}%)`}{" "}
        </div>
      ),
    },
  ];

  return (
    <>
      <div className="SubHeading  mb-3">Progress tracker</div>

      <div className="Card">
        {PTDetails && (
          <DataTable data={PTDetails} columns={PTColumns} className="NCLDataTable" Dropdownvalues={["10", "25", "50", "100"]} ShowPagination={true} ShowPagecount={true} />
        )}
      </div>

      {Load && <Loading />}
    </>
  );
};
export default PTracker;
